import React from "react";
import PropTypes from "prop-types";

import CardPanel from "../shared/CardPanel";
import CardHeader from "../shared/CardHeader";
import CardTitle from "../shared/CardSearchTable/Title";
import Row from "../shared/Row";
import InputField from "../shared/InputField";

import { useMaterialInputFields } from "../../hooks/useMaterialInputFields";
export default function Information({ estimate: { name, naics } }) {
  const header = [name, naics].filter((x) => x).join(" - ");
  return (
    <CardPanel>
      <CardTitle header={header} tooltip="New Estimate" />
      <br />
      <CardHeader text="Business Information" icon="business" />
      <Row>
        <InputField label="Business Name" name="businessName" />
        <InputField label="Doing Business As" name="dba" />
      </Row>
      <Row>
        <InputField label="Industry Name" name="industryName" />
        <InputField label="Business Started On" name="startedOn" type="date" />
      </Row>
      <Row>
        <InputField label="Account Number" name="accountNumber" />
        <InputField label="Parcel Number" name="parcelNumber" />
      </Row>

      <CardHeader text="Mailing Address" icon="mail" />
      <Row>
        <InputField label="Street Address" name="streetAddress" size="s6" />
        <InputField label="City" name="city" size="s4" />
        <InputField label="State" name="stateAbr" size="s1" />
        <InputField label="Zip" name="zip" size="s1" />
      </Row>

      <CardHeader text="Primary Contact" icon="perm_contact_calendar" />
      <Row>
        <InputField label="Name" name="contactName" size="s6" />
        <InputField label="Phone" name="phone" size="s3" />
        <InputField label="Email" name="contactEmail" size="s3" type="email" />
      </Row>
    </CardPanel>
  );
}

Information.propTypes = {
  estimate: PropTypes.shape({
    name: PropTypes.string,
    naics: PropTypes.string,
  }),
};
